"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@umich-lib/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var baseListStyles = {
  margin: '0',
  padding: '0',
  listStyle: 'none',
  maxWidth: '38rem',
  'li:not(:last-child)': {
    marginBottom: _styles.SPACING['XS']
  }
};
var StyledList = ( /*#__PURE__*/0, _styledBase["default"])('ul', {
  target: "e19ig3v50",
  label: "StyledList"
})(_objectSpread({}, baseListStyles), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnQm1CIiwiZmlsZSI6Ii4uL3NyYy9pbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5cbmltcG9ydCB7IFNQQUNJTkcgfSBmcm9tICdAdW1pY2gtbGliL3N0eWxlcydcblxuY29uc3QgYmFzZUxpc3RTdHlsZXMgPSB7XG4gIG1hcmdpbjogJzAnLFxuICBwYWRkaW5nOiAnMCcsXG4gIGxpc3RTdHlsZTogJ25vbmUnLFxuICBtYXhXaWR0aDogJzM4cmVtJyxcbiAgJ2xpOm5vdCg6bGFzdC1jaGlsZCknOiB7XG4gICAgbWFyZ2luQm90dG9tOiBTUEFDSU5HWydYUyddXG4gIH1cbn1cblxuY29uc3QgU3R5bGVkTGlzdCA9IHN0eWxlZCgndWwnKSh7XG4gIC4uLmJhc2VMaXN0U3R5bGVzXG59KVxuXG5jb25zdCBsaXN0UGFkZGluZ1N0eWxlcyA9IHtcbiAgbWFyZ2luTGVmdDogJzEuNXJlbSdcbn1cblxuY29uc3QgU3R5bGVkVUwgPSBzdHlsZWQoJ3VsJykoe1xuICAuLi5iYXNlTGlzdFN0eWxlcyxcbiAgLi4ubGlzdFBhZGRpbmdTdHlsZXMsXG4gIGxpc3RTdHlsZTogJ2Rpc2MnXG59KVxuXG5jb25zdCBTdHlsZWRPTCA9IHN0eWxlZCgnb2wnKSh7XG4gIC4uLmJhc2VMaXN0U3R5bGVzLFxuICAuLi5saXN0UGFkZGluZ1N0eWxlcyxcbiAgbGlzdFN0eWxlOiAnZGVjaW1hbCdcbn0pXG5cbmNvbnN0IExpc3QgPSAoe1xuICBjbGFzc05hbWUsXG4gIGNoaWxkcmVuLFxuICB0eXBlLFxuICAuLi5vdGhlclxufSkgPT4ge1xuICBpZiAodHlwZSA9PT0gJ2J1bGxldGVkJykge1xuICAgIHJldHVybiAoXG4gICAgICA8U3R5bGVkVUxcbiAgICAgICAgY2xhc3NOYW1lPXtjbGFzc05hbWV9XG4gICAgICAgIHsuLi5vdGhlcn1cbiAgICAgID5cbiAgICAgICAge2NoaWxkcmVufVxuICAgICAgPC9TdHlsZWRVTD5cbiAgICApXG4gIH1cblxuICBpZiAodHlwZSA9PT0gJ251bWJlcmVkJykge1xuICAgIHJldHVybiAoXG4gICAgICA8U3R5bGVkT0xcbiAgICAgICAgY2xhc3NOYW1lPXtjbGFzc05hbWV9XG4gICAgICAgIHsuLi5vdGhlcn1cbiAgICAgID5cbiAgICAgICAge2NoaWxkcmVufVxuICAgICAgPC9TdHlsZWRPTD5cbiAgICApXG4gIH1cblxuICByZXR1cm4gKFxuICAgIDxTdHlsZWRMaXN0XG4gICAgICBjbGFzc05hbWU9e2NsYXNzTmFtZX1cbiAgICAgIHsuLi5vdGhlcn1cbiAgICA+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9TdHlsZWRMaXN0PlxuICApXG59XG5cbkxpc3QucHJvcFR5cGVzID0ge1xuICB0eXBlOiBQcm9wVHlwZXMuc3RyaW5nXG59O1xuXG5leHBvcnQgZGVmYXVsdCBMaXN0OyJdfQ== */");
var listPaddingStyles = {
  marginLeft: '1.5rem'
};
var StyledUL = ( /*#__PURE__*/0, _styledBase["default"])('ul', {
  target: "e19ig3v51",
  label: "StyledUL"
})(_objectSpread({}, baseListStyles, {}, listPaddingStyles, {
  listStyle: 'disc'
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF3QmlCIiwiZmlsZSI6Ii4uL3NyYy9pbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5cbmltcG9ydCB7IFNQQUNJTkcgfSBmcm9tICdAdW1pY2gtbGliL3N0eWxlcydcblxuY29uc3QgYmFzZUxpc3RTdHlsZXMgPSB7XG4gIG1hcmdpbjogJzAnLFxuICBwYWRkaW5nOiAnMCcsXG4gIGxpc3RTdHlsZTogJ25vbmUnLFxuICBtYXhXaWR0aDogJzM4cmVtJyxcbiAgJ2xpOm5vdCg6bGFzdC1jaGlsZCknOiB7XG4gICAgbWFyZ2luQm90dG9tOiBTUEFDSU5HWydYUyddXG4gIH1cbn1cblxuY29uc3QgU3R5bGVkTGlzdCA9IHN0eWxlZCgndWwnKSh7XG4gIC4uLmJhc2VMaXN0U3R5bGVzXG59KVxuXG5jb25zdCBsaXN0UGFkZGluZ1N0eWxlcyA9IHtcbiAgbWFyZ2luTGVmdDogJzEuNXJlbSdcbn1cblxuY29uc3QgU3R5bGVkVUwgPSBzdHlsZWQoJ3VsJykoe1xuICAuLi5iYXNlTGlzdFN0eWxlcyxcbiAgLi4ubGlzdFBhZGRpbmdTdHlsZXMsXG4gIGxpc3RTdHlsZTogJ2Rpc2MnXG59KVxuXG5jb25zdCBTdHlsZWRPTCA9IHN0eWxlZCgnb2wnKSh7XG4gIC4uLmJhc2VMaXN0U3R5bGVzLFxuICAuLi5saXN0UGFkZGluZ1N0eWxlcyxcbiAgbGlzdFN0eWxlOiAnZGVjaW1hbCdcbn0pXG5cbmNvbnN0IExpc3QgPSAoe1xuICBjbGFzc05hbWUsXG4gIGNoaWxkcmVuLFxuICB0eXBlLFxuICAuLi5vdGhlclxufSkgPT4ge1xuICBpZiAodHlwZSA9PT0gJ2J1bGxldGVkJykge1xuICAgIHJldHVybiAoXG4gICAgICA8U3R5bGVkVUxcbiAgICAgICAgY2xhc3NOYW1lPXtjbGFzc05hbWV9XG4gICAgICAgIHsuLi5vdGhlcn1cbiAgICAgID5cbiAgICAgICAge2NoaWxkcmVufVxuICAgICAgPC9TdHlsZWRVTD5cbiAgICApXG4gIH1cblxuICBpZiAodHlwZSA9PT0gJ251bWJlcmVkJykge1xuICAgIHJldHVybiAoXG4gICAgICA8U3R5bGVkT0xcbiAgICAgICAgY2xhc3NOYW1lPXtjbGFzc05hbWV9XG4gICAgICAgIHsuLi5vdGhlcn1cbiAgICAgID5cbiAgICAgICAge2NoaWxkcmVufVxuICAgICAgPC9TdHlsZWRPTD5cbiAgICApXG4gIH1cblxuICByZXR1cm4gKFxuICAgIDxTdHlsZWRMaXN0XG4gICAgICBjbGFzc05hbWU9e2NsYXNzTmFtZX1cbiAgICAgIHsuLi5vdGhlcn1cbiAgICA+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9TdHlsZWRMaXN0PlxuICApXG59XG5cbkxpc3QucHJvcFR5cGVzID0ge1xuICB0eXBlOiBQcm9wVHlwZXMuc3RyaW5nXG59O1xuXG5leHBvcnQgZGVmYXVsdCBMaXN0OyJdfQ== */");
var StyledOL = ( /*#__PURE__*/0, _styledBase["default"])('ol', {
  target: "e19ig3v52",
  label: "StyledOL"
})(_objectSpread({}, baseListStyles, {}, listPaddingStyles, {
  listStyle: 'decimal'
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE4QmlCIiwiZmlsZSI6Ii4uL3NyYy9pbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5cbmltcG9ydCB7IFNQQUNJTkcgfSBmcm9tICdAdW1pY2gtbGliL3N0eWxlcydcblxuY29uc3QgYmFzZUxpc3RTdHlsZXMgPSB7XG4gIG1hcmdpbjogJzAnLFxuICBwYWRkaW5nOiAnMCcsXG4gIGxpc3RTdHlsZTogJ25vbmUnLFxuICBtYXhXaWR0aDogJzM4cmVtJyxcbiAgJ2xpOm5vdCg6bGFzdC1jaGlsZCknOiB7XG4gICAgbWFyZ2luQm90dG9tOiBTUEFDSU5HWydYUyddXG4gIH1cbn1cblxuY29uc3QgU3R5bGVkTGlzdCA9IHN0eWxlZCgndWwnKSh7XG4gIC4uLmJhc2VMaXN0U3R5bGVzXG59KVxuXG5jb25zdCBsaXN0UGFkZGluZ1N0eWxlcyA9IHtcbiAgbWFyZ2luTGVmdDogJzEuNXJlbSdcbn1cblxuY29uc3QgU3R5bGVkVUwgPSBzdHlsZWQoJ3VsJykoe1xuICAuLi5iYXNlTGlzdFN0eWxlcyxcbiAgLi4ubGlzdFBhZGRpbmdTdHlsZXMsXG4gIGxpc3RTdHlsZTogJ2Rpc2MnXG59KVxuXG5jb25zdCBTdHlsZWRPTCA9IHN0eWxlZCgnb2wnKSh7XG4gIC4uLmJhc2VMaXN0U3R5bGVzLFxuICAuLi5saXN0UGFkZGluZ1N0eWxlcyxcbiAgbGlzdFN0eWxlOiAnZGVjaW1hbCdcbn0pXG5cbmNvbnN0IExpc3QgPSAoe1xuICBjbGFzc05hbWUsXG4gIGNoaWxkcmVuLFxuICB0eXBlLFxuICAuLi5vdGhlclxufSkgPT4ge1xuICBpZiAodHlwZSA9PT0gJ2J1bGxldGVkJykge1xuICAgIHJldHVybiAoXG4gICAgICA8U3R5bGVkVUxcbiAgICAgICAgY2xhc3NOYW1lPXtjbGFzc05hbWV9XG4gICAgICAgIHsuLi5vdGhlcn1cbiAgICAgID5cbiAgICAgICAge2NoaWxkcmVufVxuICAgICAgPC9TdHlsZWRVTD5cbiAgICApXG4gIH1cblxuICBpZiAodHlwZSA9PT0gJ251bWJlcmVkJykge1xuICAgIHJldHVybiAoXG4gICAgICA8U3R5bGVkT0xcbiAgICAgICAgY2xhc3NOYW1lPXtjbGFzc05hbWV9XG4gICAgICAgIHsuLi5vdGhlcn1cbiAgICAgID5cbiAgICAgICAge2NoaWxkcmVufVxuICAgICAgPC9TdHlsZWRPTD5cbiAgICApXG4gIH1cblxuICByZXR1cm4gKFxuICAgIDxTdHlsZWRMaXN0XG4gICAgICBjbGFzc05hbWU9e2NsYXNzTmFtZX1cbiAgICAgIHsuLi5vdGhlcn1cbiAgICA+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9TdHlsZWRMaXN0PlxuICApXG59XG5cbkxpc3QucHJvcFR5cGVzID0ge1xuICB0eXBlOiBQcm9wVHlwZXMuc3RyaW5nXG59O1xuXG5leHBvcnQgZGVmYXVsdCBMaXN0OyJdfQ== */");

var List = function List(_ref) {
  var className = _ref.className,
      children = _ref.children,
      type = _ref.type,
      other = _objectWithoutProperties(_ref, ["className", "children", "type"]);

  if (type === 'bulleted') {
    return (0, _core.jsx)(StyledUL, _extends({
      className: className
    }, other), children);
  }

  if (type === 'numbered') {
    return (0, _core.jsx)(StyledOL, _extends({
      className: className
    }, other), children);
  }

  return (0, _core.jsx)(StyledList, _extends({
    className: className
  }, other), children);
};

List.propTypes = {
  type: _propTypes["default"].string
};
var _default = List;
exports["default"] = _default;